import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const ANIMATION_STATES = {
  GENERAL: "general",
  THINKING: "thinking",
  SUCCESS: "success",
  SAD: "sad",
} as const;

type AnimationState = (typeof ANIMATION_STATES)[keyof typeof ANIMATION_STATES];

interface TaxAIResponseState {
  animationState: AnimationState;
}

const initialState: TaxAIResponseState = {
  animationState: ANIMATION_STATES.GENERAL,
};

const taxAIResponse = createSlice({
  name: "taxAIResponse",
  initialState,
  reducers: {
    setAnimationState: (state, action: PayloadAction<AnimationState>) => {
      state.animationState = action.payload;
    },
    startThinking: (state) => {
      state.animationState = ANIMATION_STATES.THINKING;
    },
    showSuccess: (state) => {
      state.animationState = ANIMATION_STATES.SUCCESS;
    },
    showSad: (state) => {
      state.animationState = ANIMATION_STATES.SAD;
    },
    resetToGeneral: (state) => {
      state.animationState = ANIMATION_STATES.GENERAL;
    },
  },
});

export const {
  setAnimationState,
  startThinking,
  showSuccess,
  showSad,
  resetToGeneral,
} = taxAIResponse.actions;

export default taxAIResponse.reducer;
